export default __webpack_public_path__ + "static/media/Antonio_Perillo_Marcone.069080db.jpeg";